import { useEffect } from "react";
import { Link } from "react-router-dom";
import NavBar from "../features/navbar/Navbar";
import ProductList from "../features/product/components/ProductList";
import Footer from "../features/common/Footer";
import MainLayout from "../components/MainLayout";

function Home() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return ( 
        <MainLayout>
            <NavBar>
                <ProductList></ProductList>
            </NavBar>
            <Footer></Footer>
        </MainLayout>
     );
}

export default Home;